export const REASON_ABSENCE = "REASON_ABSENCE";
export const REASON_REQUEST = "REASON_REQUEST";
export const REASON_ADDRESS_ERROR = "REASON_ADDRESS_ERROR";
export const REASON_MOBILE_ERROR = "REASON_MOBILE_ERROR";
export const REASON_NO_SPACE = "REASON_NO_SPACE";
export const REASON_HEAVY_RAIN = "REASON_HEAVY_RAIN";
export const REASON_HEAVY_SNOW = "REASON_HEAVY_SNOW";
export const REASON_VEHICLE_FAULT = "REASON_VEHICLE_FAULT";
export const REASON_WRONG_ADDRESS = "REASON_WRONG_ADDRESS";
export const REASON_NOT_TODAY = "REASON_NOT_TODAY";
export const REASON_MISCLASSIFICATION = "REASON_MISCLASSIFICATION";
export const REASON_NO_CONTACT = "REASON_NO_CONTACT";
export const REASON_NO_STORAGE = "REASON_NO_STORAGE";
export const REASON_NEXT_DELIVERY = "REASON_NEXT_DELIVERY";
export const REASON_ROAD_PROBLEM = "REASON_ROAD_PROBLEM";
export const REASON_DELIVERY_ADDRESS_PROBLEM =
  "REASON_DELIVERY_ADDRESS_PROBLEM";
export const REASON_RECEIVER_REFUSAL = "REASON_RECEIVER_REFUSAL";
export const REASON_UNHANDLEABLE_CARGO = "REASON_UNHANDLEABLE_CARGO";
export const REASON_MISDELIVERY_RETURN_REQUEST =
  "REASON_MISDELIVERY_RETURN_REQUEST";
export const REASON_PRODUCT_DAMAGE = "REASON_PRODUCT_DAMAGE";
export const REASON_ETC = "REASON_ETC";

export const DELAY_REASONS = [
  {
    text: "다음 회차",
    code: REASON_NEXT_DELIVERY,
  },
  {
    text: "수령인 부재",
    code: REASON_ABSENCE,
  },
  {
    text: "고객지정일(수령인 요청)",
    code: REASON_REQUEST,
  },
  {
    text: "주소지 오류",
    code: REASON_ADDRESS_ERROR,
  },
  {
    text: "연락처 오류",
    code: REASON_MOBILE_ERROR,
  },
  {
    text: "출입불가 및 보관장소없음",
    code: REASON_NO_SPACE,
  },
  {
    text: "수취거부",
    code: REASON_RECEIVER_REFUSAL,
    shortText: "수취거부",
  },
  {
    text: "취급불가 화물",
    code: REASON_UNHANDLEABLE_CARGO,
    shortText: "취급불가",
  },
  {
    text: "오배송반송요청",
    code: REASON_MISDELIVERY_RETURN_REQUEST,
    shortText: "오배송반송",
  },
  {
    text: "오분류",
    code: REASON_MISCLASSIFICATION,
  },
  {
    text: "배송불가지역",
    code: REASON_WRONG_ADDRESS,
  },
  {
    text: "기상악화(폭우)",
    code: REASON_HEAVY_RAIN,
  },
  {
    text: "기상악화(폭설)",
    code: REASON_HEAVY_SNOW,
  },
  {
    text: "도로문제(도로통제등)",
    code: REASON_ROAD_PROBLEM,
  },
  {
    text: "배송지문제(정전등)",
    code: REASON_DELIVERY_ADDRESS_PROBLEM,
  },
  {
    text: "차량사고(차량고장)",
    code: REASON_VEHICLE_FAULT,
  },
  {
    text: "상품 파손",
    code: REASON_PRODUCT_DAMAGE,
  },
  {
    text: "순차배송예정(영업일 익일배송)",
    code: REASON_NOT_TODAY,
  },
  {
    text: "기타",
    code: REASON_ETC,
  },
];

export const PICKUP_DELAY_REASONS = [
  {
    text: "고객 연락 불가",
    code: REASON_NO_CONTACT,
  },
  {
    text: "출입불가",
    code: REASON_NO_SPACE,
  },
  {
    text: "고객지정일(고객 요청)",
    code: REASON_REQUEST,
  },
  {
    text: "주소지 오류",
    code: REASON_ADDRESS_ERROR,
  },
  {
    text: "기상악화(폭우)",
    code: REASON_HEAVY_RAIN,
  },
  {
    text: "기상악화(폭설)",
    code: REASON_HEAVY_SNOW,
  },
  {
    text: "도로문제(도로통제등)",
    code: REASON_ROAD_PROBLEM,
  },
  {
    text: "배송지문제(정전등)",
    code: REASON_DELIVERY_ADDRESS_PROBLEM,
  },
  {
    text: "차량사고(차량고장)",
    code: REASON_VEHICLE_FAULT,
  },
  {
    text: "보관물품 없음",
    code: REASON_NO_STORAGE,
  },
  {
    text: "순차처리예정",
    code: REASON_NOT_TODAY,
  },
  {
    text: "기타",
    code: REASON_ETC,
  },
];
